<template>
  <content />
</template>

<script setup>
import { Content } from 'vuepress/client';
</script>
